import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { gettemplatemasterData, InserttemplatemasterData, postDispatchTemplateDetails } from '../store/actions/dispatchOrderDetailsActions'
import { Link } from "react-router-dom";
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import authInstance from '../Classes/AuthHandler';
import toast from 'react-hot-toast';
import dateFormater from '../Classes/FormatDateTimeInIST';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import swal from 'sweetalert';
import Select from 'react-select';

class DispatchAddTemplate extends Component {
    constructor() {
        super()
        this.state = {
            show: false,
            TemplateName: "",
            addDocumentmodal: false,
            tableData: [],
            dispatchTemplateId: 0,
            dropdownarray: [],
            projectNo:"",
            dropdownarray1:[],
            peojectCodeValueDropDwon:{}
        }
    }
    componentDidMount() {
        this.dataSync()
    }
    dataSync = async () => {
        let tableData = []
        let dropdownarray = []
        let dropdownarray1 = [
            {"label": 'Other (For Non WBS)',"value":'Other'},
            {"label": 'Other (for C Series)',"value":'Other (for C Series)'},
            {"label": 'Service orders Khurda',"value":'Service orders Khurda'},
            {"label": 'Service orders Gurgaon',"value":'Service orders Gurgaon'},
            {"label": 'Service orders Concast',"value":'Service orders Concast'},
        ]
        await this.props.gettemplatemasterData()
        tableData = await this.props.dispatchOrderDetailsReducer.getdispatchtemplatemasterdata.recordset
        dropdownarray = await this.props.dispatchOrderDetailsReducer.getdispatchtemplatemasterdata.recordsets[1].filter(data=>!data.WBSCode == '')
        // to set the WBS code as project no based on the plant code
        dropdownarray.map((data)=>{
            if((data.WBSCode).substring(0, 2) == "ET"){
                data.WBSCode = data.WBSCode.slice(0,11)
            }else{
                data.WBSCode = data.WBSCode.slice(0,6)
            }
        })
        // to remove duplicate elements from dropdownarray.
        dropdownarray.map(elem=>{
            if(dropdownarray1.filter(data=> data.value == elem.WBSCode).length == 0){
                dropdownarray1.push({"label": elem.WBSCode, "value": elem.WBSCode})
            }
        })
        await this.setState({ tableData,dropdownarray,dropdownarray1 })

    }

    addDocumentmodal(indicator) {
        this.setState({ addDocumentmodal: !this.state.addDocumentmodal, indicator });
        if (this.state.addDocumentmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    deletetemplatemodal(dispatchTemplateId) {
        this.setState({ deletetemplatemodal: !this.state.deletetemplatemodal });
        if (this.state.deletetemplatemodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2", dispatchTemplateId }
            )
        }
    }
    handlerTemplateName = (event) => {
        console.log(event.target.value);
        this.setState({ TemplateName: event.target.value });
    }
    addTemplate = async () => {
        if (this.state.TemplateName == '') {
            swal("Kindly Input a Valid Name", { icon: "error" })
            return false;
        }
        if (this.state.projectNo == '') {
            swal("Kindly Select a valid Project No", { icon: "error" })
            return false;
        }
        let input = {
            TemplateName: this.state.TemplateName,
            CreatedBy: authInstance.getUserID(),
            dispatchTemplateId: 0,
            ProjectNo:this.state.projectNo,
        }
        await this.props.InserttemplatemasterData(input)
        await toast.success(`${this.state.TemplateName} has been added`, {
            duration: 4000
        });
        await this.addDocumentmodal()
        await this.dataSync()
    }
    handleTemplateName = (e, Index) => {
        let input = e.target.value
        let tableData = [...this.state.tableData]
        tableData[Index].TemplateName = input
        this.setState({ tableData })
    }
    saveData = async (val, Index) => {
        if (val == 18) {
            let input = {
                indicator: val,
                TemplateName: this.state.tableData[Index].TemplateName,
                TemplateId: this.state.tableData[Index].dispatchTemplateId,
                
            }
            await this.props.postDispatchTemplateDetails(input)
        }
        await this.dataSync()
        await toast.success(`Successfully Saved`, {
            duration: 3000
        });
    }
    handleDelete = async (data) => {
        let input = {
            dispatchTemplateId: data,
        }
        await this.props.InserttemplatemasterData(input)
        await this.deletetemplatemodal()
        await this.dataSync()
        await toast.success(`Successfully Deleted`, {
            duration: 3000
        });
    }
    handleProjectNo=(input)=>{
        let inputVal = input
        this.setState({projectNo:inputVal.value, pojectCodeValueDropDwon:inputVal })
    }
    render() {
        console.log("GFGFGFGFGF",this.state.projectNo)
        return (
            <div className="container">
                {/* Add Document MODAL starts */}
                <Modal isOpen={this.state.addDocumentmodal} >
                    <div className={"modal-bg" + (this.state.addDocumentmodal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Add Template </h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={(e) => this.addDocumentmodal(e)} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-5"><b>Template Name :</b></div>
                                    <div className="col-md-7">
                                        <input type="text" className="form-control" value={this.state.TemplateName} onChange={(e) => this.handlerTemplateName(e)}></input>
                                    </div>
                                </div>
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-5"><b>Project Number :</b></div>
                                    <div className="col-md-7">
                                        <Select maxMenuHeight={500} value={this.state.pojectCodeValueDropDwon}  
                                         options={this.state.dropdownarray1}
                                           onChange={(e) => this.handleProjectNo(e)} />
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.addDocumentmodal()} type="submit">Cancel</button>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.addTemplate()} type="submit">Add Template</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                {/* Add Document MODAL ENDS */}
                {/* WANT TO DELETE TEMPLATE MODAL starts */}
                <Modal isOpen={this.state.deletetemplatemodal} >
                    <div className={"modal-bg" + (this.state.deletetemplatemodal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Delete Template </h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={(e) => this.deletetemplatemodal(e)} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-10"><b>Are You Sure To Delete Template ?</b></div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className=" btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.deletetemplatemodal()} type="submit">NO</button>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.handleDelete(this.state.dispatchTemplateId)} type="submit">YES</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                <div className="w-100 mx-auto shadow p-5" style={{ marginTop: "1%" }}>
                    <form onSubmit={this.handleSubmit}>
                        <div className="row mb-4">
                            <div className="col-md-2">
                                <h5>Add Template</h5>
                            </div>
                            <div className="col-md-4">
                                <i className="fas fa-plus-circle fa-lg" onClick={() => this.addDocumentmodal()} style={{ cursor: 'pointer', backgroundColor: 'white', color: 'blue' }}></i>
                            </div>
                        </div>
                        <table className="table1" style={{width: '-webkit-fill-available'}}>
                            <thead className="thead" style={{ backgroundColor: "#0989CB" }}>
                                <tr>
                                    <th scope="col">Project No.</th>
                                    <th scope="col">Template Name</th>
                                    <th scope="col">Created On</th>
                                    <th scope="col">Created By</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.tableData.map((item, Index) =>
                                    <tr>
                                        <td>{item.ProjectNo}</td>
                                        <td><input className="form-control" type="text" value={item.TemplateName} onChange={(e) => this.handleTemplateName(e, Index)} onBlur={() => this.saveData(18, Index)} /></td>
                                        <td style={{ textAlign: "center" }}>{item.CreatedOn ? dateFormater(item.CreatedOn) : null}</td>
                                        <td>{item.FullName}</td>
                                        <td style={{ textAlign: "center" }}>
                                            <Link to={{ pathname: '/DispatchTemplate', state: { TemplateId: item.dispatchTemplateId, TemplateName: item.TemplateName } }}>
                                                <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" cursor="pointer" />
                                            </Link>
                                            <FontAwesomeIcon className="ml-2" icon={"trash-alt"} color="red" title="Delete" cursor="pointer" onClick={() => this.deletetemplatemodal(item.dispatchTemplateId)} />
                                        </td>
                                    </tr>
                                )
                                }
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({ dispatchOrderDetailsReducer: state.dispatchOrderDetailsReducer })
export default connect(mapStateToProps, { gettemplatemasterData, InserttemplatemasterData, postDispatchTemplateDetails })(DispatchAddTemplate)
